import _ from 'lodash'

const pagingKeys = ['limit', 'start'] as const
export function withoutPagingQuery(query: object): object {
  return _.omit(query, pagingKeys)
}
